<section class="benefit-modal__background">
	<section class="benefit-modal__body">
		<section class="benefit-modal__header">
			<button class="benefit-modal__close-button" (click)="onAccept()">
				<i class="bi bi-x-lg"></i>
			</button>
			<img [src]="image" [alt]="title" class="benefit-modal__header-image" />
		</section>

		<main class="benefit-modal__content">
			<h1 class="benefit-modal__title">{{ title }}</h1>
			<p class="benefit-modal__message">
				{{ message }}
			</p>
			<button class="benefit-modal__accept-button" (click)="onAccept()">
				Aceptar
			</button>
		</main>
	</section>
</section>
